/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs */

const en_admin_dashboard_empty_state_bookings_revenue_add_resources = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add resources`)
};

const de_admin_dashboard_empty_state_bookings_revenue_add_resources = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressourcen hinzufügen`)
};

const es_admin_dashboard_empty_state_bookings_revenue_add_resources = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir recursos`)
};

const fr_admin_dashboard_empty_state_bookings_revenue_add_resources = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter des ressources`)
};

const nl_admin_dashboard_empty_state_bookings_revenue_add_resources = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorzieningen toevoegen`)
};

const it_admin_dashboard_empty_state_bookings_revenue_add_resources = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi risorse`)
};

const pt_br2_admin_dashboard_empty_state_bookings_revenue_add_resources = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar recursos`)
};

const pl_admin_dashboard_empty_state_bookings_revenue_add_resources = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj zasoby`)
};

const hu_admin_dashboard_empty_state_bookings_revenue_add_resources = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erőforrások hozzáadása`)
};

const ro_admin_dashboard_empty_state_bookings_revenue_add_resources = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaugati resurse`)
};

/**
* | output |
* | --- |
* | "Add resources" |
*
* @param {Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_empty_state_bookings_revenue_add_resources = /** @type {((inputs?: Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Empty_State_Bookings_Revenue_Add_ResourcesInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_empty_state_bookings_revenue_add_resources(inputs)
	if (locale === "de") return de_admin_dashboard_empty_state_bookings_revenue_add_resources(inputs)
	if (locale === "es") return es_admin_dashboard_empty_state_bookings_revenue_add_resources(inputs)
	if (locale === "fr") return fr_admin_dashboard_empty_state_bookings_revenue_add_resources(inputs)
	if (locale === "nl") return nl_admin_dashboard_empty_state_bookings_revenue_add_resources(inputs)
	if (locale === "it") return it_admin_dashboard_empty_state_bookings_revenue_add_resources(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_empty_state_bookings_revenue_add_resources(inputs)
	if (locale === "pl") return pl_admin_dashboard_empty_state_bookings_revenue_add_resources(inputs)
	if (locale === "hu") return hu_admin_dashboard_empty_state_bookings_revenue_add_resources(inputs)
	return ro_admin_dashboard_empty_state_bookings_revenue_add_resources(inputs)
});
export { admin_dashboard_empty_state_bookings_revenue_add_resources as "admin.dashboard.empty_state.bookings_revenue.add_resources" }